import { useLocation } from "react-router-dom";
import FolderTicket from "./Folder";

export default function Card({ limit }) {
  const location = useLocation();
  const isMerchPage = location.pathname.includes("/merch");

  return (
    <>
      {!isMerchPage && (
        <>
          <div className="bg-white text-black py-10 md:py-20 flex items-center justify-center">
            <div className="font-bold md:text-[70px] text-[40px] font-Neuehaasdisplay md:leading-[65px] text-center whitespace-nowrap">
              T<span className="font-dirtyline">I</span>C
              <span className="font-dirtyline">K</span>E
              <span className="font-dirtyline">T</span>&nbsp;A
              <span className="font-dirtyline">N</span>D&nbsp;M
              <span className="font-dirtyline">E</span>R
              <span className="font-dirtyline">C</span>H
            </div>
          </div>
          {/* Two folder components centered */}
          <div className="bg-white py-10 md:py-20 flex items-center justify-center gap-6 sm:gap-8 md:gap-12 lg:gap-16">
            <FolderTicket link="/tickets" text="TICKETS" delay={0} />
            <FolderTicket link="/merch" text="MERCH" delay={1750} />
          </div>
        </>
      )}
    </>
  );
}
